const getSessionState = (state) => state && state.session ? state.session : {};

// User info
export const loggedInUser = (state) => getSessionState(state).loggedInUser;
export const userId = (state) => getSessionState(state).userId;
export const organizationId = (state) => getSessionState(state).organizationId;
export const organizationName = (state) => getSessionState(state).organizationName;
export const role = (state) => getSessionState(state).role;

// UI state
export const loggingIn = (state) => getSessionState(state).loggingIn;
export const loggingOut = (state) => getSessionState(state).loggingOut;
export const checkingSession = (state) => getSessionState(state).checkingSession;
export const sessionChecked = (state) => getSessionState(state).sessionChecked;
export const loginErrorMessage = (state) => getSessionState(state).loginErrorMessage;
export const sessionWarningVisible = (state) => getSessionState(state).sessionWarningVisible;
export const extendingSession = (state) => getSessionState(state).extendingSession;

// User profile selectors
const getUserProfileModel = (state) => getSessionState(state).userProfileModel || {};
export const userProfile = (state) => getUserProfileModel(state).userProfile;
export const userProfileIsLoading = (state) => getUserProfileModel(state).isLoading;
export const userProfileErrorMessage = (state) => getUserProfileModel(state).errorMessage;
export const userProfileDialogOpen = (state) => getUserProfileModel(state).profileDialogOpen;
